"use client";

import type { ImageLoaderProps } from "next/image";

/**
 * Custom Next.js loader that routes Storyblok asset requests through
 * Storyblok's image service. When `focus` is provided, the service
 * performs smart cropping that keeps the focal point in view at the
 * requested size.
 *
 * Output URL pattern:
 *   <src>/m/<width>x<height>/smart/filters:quality(<q>):focal(<focus>)
 *
 * Pass height=0 (the default) to let Storyblok pick a height based on
 * the source aspect ratio.
 *
 * SVGs are returned unchanged — Storyblok's image service can mangle
 * vector files.
 */
export default function sbImageLoader({
  src,
  width,
  quality = 80,
  height = 0,
  focus,
}: ImageLoaderProps & {
  height?: number;
  focus?: string;
}): string {
  if (src.endsWith(".svg")) return src;

  let filters = `filters:quality(${quality}):no_upscale()`;
  if (focus) filters += `:focal(${focus})`;

  return `${src}/m/${width}x${height}/smart/${filters}`;
}
